export default {
    // --------Title--------
    logisticType: '物流类型',
    logisticInfo: '物流信息',
    document: '文件',
    basicInformationAboutTheDocument: '文件基本信息',
    relatedWarehouseLocationToProcess: '处理仓库相关位置',

    // --------DIalog-------
    searchTripDocuments: '搜索行程文件',
    documentType: '文件类型',
    searchDocumentNo: '搜索文件号',
    profileName: '档案名称',
    confirmSelection: '确认选项',
    reset: '重置',
    noRecordsAvailable: '无记录',

    // --------MUI--------
    label: '标签',
    vehiclePlateNo: '载具牌号',            
    vehicleModel: '载具型号',            
    vehicleBrand: '载具品牌',   
    
    date: '日期',
    driver: '司机',
    logistic: '物流',
    completion: '完成情况',
    completed: '已完成',
    incomplete: '未完成',
    pending: '待处理',
    referenceNo: '参考编号',
    locationFrom: '起始地点',
    documentNumber: '文件号',
    logistics: '物流',

    confirmedAt: '已确认于',
    markAsConfirm: '标记为确认',
    yesIveConfirmed: '是的, 我已确认',
};